import { useEffect } from 'react';

export const useEscapeKeydown = (callback: () => void) => {
    useEffect(() => {
        const handleKeydown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                callback();
            }
        };

        document.addEventListener('keydown', handleKeydown);
        return () => {
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [callback]);
};

export default useEscapeKeydown;
